import { CORSOADOZIONALE, SLUG, VOLUME } from 'utils/endpoint'
import { api, CAS_DOMAIN } from 'utils'
import React, { useEffect, useMemo, useState } from 'react'
import { Image } from 'react-components/atoms'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import Error from 'next/error'
import MetaSeo from 'components/atomic/MetaSeo'
import PlaceholderReact from 'components/atomic/PlaceholderReact'
import { useRouter } from 'next/router'
import { api as pagebuilderApi } from 'react-pagebuilder/services/api'
import { useDispatch } from 'react-redux'
import { setItem } from 'containers/toolbar'
import { Button, NewTags, TabGroup } from 'react-components/atoms'
import { useTrans } from 'hooks'
import { Bar, GenericPageTab, StickyActions } from 'react-components/organisms'
import Credits from 'components/atomic/Credits'
import { ArrowDown } from 'react-components/atoms/Icons'
import {
  BoxAdozioneCorso,
  CardConfigurazione,
  CardParascolastico,
} from 'react-components/molecules'
import { sendProductImpressionGTM, sendProductDetailGTM, sendGTMData } from '../../utils/gtm'

const AdozionaleDetail = ({ item, page, newDefaultContent, statusCode }) => {
  if (!item) return <Error statusCode={statusCode} />

  const t = useTrans()

  const dispatch = useDispatch()

  const router = useRouter()

  const [adozionale, setAdozionale] = useState(item)
  const [configurazioni, setConfigurazioni] = useState([])

  const [anchor, setAnchor] = useState('')

  const refresh = async () => {
    const { data } = await api.get(`${CORSOADOZIONALE}${adozionale.id}/`)
    setAdozionale(data)
    sendProductDetailGTM(data, 'navigazione_standard')
    dispatch(setItem(data))
  }

  useEffect(() => {
    if (configurazioni) {
      sendProductImpressionGTM(configurazioni, 'prodotti_correlati')
    }
  }, [configurazioni])

  useEffect(() => {
    refresh()
    initConfigurazioni()
  }, [])

  useEffect(() => {
    if (router.asPath) initAnchor()
  }, [router.asPath])

  function initAnchor() {
    const anchor = router.asPath.split('#')[1]
    if (anchor) setAnchor(anchor)
  }

  async function initConfigurazioni() {
    const params = { corsoadozionale: adozionale.id }
    const { data } = await api.get(VOLUME, { params })
    setConfigurazioni(data)
  }

  const handleGTM = (item) => {
    sendGTMData({
      event: 'GAevent',
      eventID: '27',
      eventCategory: 'card_volumi',
      eventAction: item.toGTMFormat(),
      eventLabel: adozionale.titolo.toGTMFormat(),
    })
  }

  const tabs = useMemo(
    () =>
      adozionale.tabs.map((tab, index) => ({
        key: tab.slug,
        label: tab.titolo,
        content: (
          <GenericPageTab tab={tab}>
            <PlaceholderReact
              contentTypeId={adozionale.model}
              objectId={adozionale.id}
              pkey={`${adozionale.id}-${tab.slug}-content`}
              serverSideContent={index === 0 ? newDefaultContent : null}
            />
          </GenericPageTab>
        ),
      })),
    [adozionale]
  )

  return (
    <main className={`catalogo-page ${!tabs.length ? 'catalogo-page--no-tabs' : ''}`}>
      <MetaSeo seo={page.seo} />
      <div className="w-container">
        <Breadcrumbs breadcrumbs={page.breadcrumbs} />
      </div>
      <div className="w-container">
        <div className="catalogo-page__sticky-container">
          <StickyActions item={adozionale} labelGTM={'adozionale'} share />
        </div>
        <div className="catalogo-page__header-container">
          <div className="catalogo-page__header">
            {adozionale.main_image && (
              <div className="catalogo-page__image-box">
                <Image
                  src={CAS_DOMAIN + adozionale.main_image}
                  alt={adozionale.titolo.toAltTitle()}
                  title={adozionale.titolo.toAltTitle()}
                  width={285}
                  height={360}
                  priority
                />
              </div>
            )}
            <div className="catalogo-page__summary">
              <h2 className="catalogo-page__intro">{adozionale.tipologia || 'corso adozionale'}</h2>
              <h1 className="catalogo-page__title">{adozionale.titolo}</h1>
              <NewTags
                tassonomia={adozionale.tassonomia}
                discipline
                className="catalogo-page__tags"
              />
              <p className="catalogo-page__abstract">{adozionale.descrizione}</p>
              <div className="catalogo-page__editore">
                Editore <b>{adozionale.editore || t('SOC. GIUNTI SCUOLA')}</b>
              </div>
              <div className="catalogo-page__cta-box">
                <Button
                  className="catalogo-page__cta-box__cta"
                  label={t('Contatta un agente')}
                  href="/trova-agente"
                  onClick={() => handleGTM(t('Contatta un agente'))}
                />
                <Button
                  className="catalogo-page__cta-box__cta"
                  label={t('Vai alla demo dBookEasy')}
                  href={adozionale.link_dbook_easy}
                  onClick={() => handleGTM(t('Vai alla demo dBookEasy'))}
                  variant="secondary"
                  external
                  newPage
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="catalogo-page__tabs">
        <div className="w-container">
          <TabGroup
            tabs={tabs}
            initialKey={anchor}
            className="catalogo-page__tabgroup"
            variant="white"
          />
          {tabs.map((tab) => (
            <Credits
              label={tab.label}
              crediti={tab.content}
              classes="catalogo-page__credits"
              variant="catalogo"
              icon={<ArrowDown />}
              initialOpen={anchor === tab.key}
              href={`#${tab.key}`}
              key={tab.slug}
            />
          ))}
        </div>
      </div>
      {configurazioni.length ? (
        <div className="catalogo-page__box-configurazioni">
          <div className="w-container">
            <h3 className="catalogo-page__box-configurazioni__title">
              {t('Configurazioni e volumi')}
            </h3>
            <div className="catalogo-page__box-configurazioni__content">
              {configurazioni.map((c, index) => (
                // <CardConfigurazione
                <CardParascolastico
                  className="catalogo-page__parascolastici__card"
                  // configurazione={c}
                  parascolastico={c}
                  variant="white"
                  key={c.id}
                  position={index + 1}
                  parentList={'prodotti_correlati'}
                />
              ))}
            </div>
          </div>
        </div>
      ) : null}
      <BoxAdozioneCorso className="catalogo-page__box-adozione" />
      <Bar item={adozionale} share labelGTM={'adozionale'}>
        <Button label={t('Contatta un agente')} href="/trova-agente" />
      </Bar>
    </main>
  )
}

export async function getStaticPaths() {
  const response = await api.get(CORSOADOZIONALE)
  const aodozionali = response.data

  const paths = aodozionali
    .map((s) => {
      return { params: { slug: s.slug } }
    })
    .slice(0, 1)

  return {
    paths,
    fallback: 'blocking',
  }
}

export const getStaticProps = async ({ params: { slug }, preview, previewData }) => {
  const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

  const response = await api.get(
    `${CORSOADOZIONALE}${SLUG}${slug}/`,
    { params: { preview } },
    { headers }
  )
  const item = response.data

  if (!item) {
    return {
      notFound: true,
    }
  }

  let newDefaultContent = null

  if (item.tabs.length) {
    newDefaultContent = await pagebuilderApi.getPagebuilder({
      contentTypeId: item.model,
      objectId: item.id,
      key: item.id + '-' + item.tabs[0].slug + '-content',
      edit_mode: false,
    })
  }

  const page = item.pagina

  const toolbarProps = { toolbarItem: item, toolbarPage: page }

  return {
    props: {
      item,
      page,
      newDefaultContent,
      key: item.id,
      ...toolbarProps,
      revalidate: 60 * 10, // trovare alternativa in stile data-fetching-wrapper di Luca D. per altre pagine senza dover passare manualmente il revalidate
    },
    revalidate: 60 * 10,
  }
}

export default AdozionaleDetail
